import React, { useState } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import { cn } from 'components/lib/utils';
import { Separator } from 'components/ui/separator';

export const FormsSeparator = () => (
  <Separator className="bg-base-border ml-2 w-[290px]" />
);

export const MergeSeparator: React.FC<{ onMerge: () => void }> = ({
  onMerge
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="relative flex items-center cursor-pointer ml-2 w-[290px]"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onMerge}
    >
      <Separator
        className={cn(
          'w-full transition-colors',
          isHovered ? 'bg-indigo-500' : 'bg-base-border'
        )}
      />
      <div
        className={cn(
          'absolute left-[60%] -translate-x-1/2 z-10 flex items-center justify-center w-7 h-7 bg-white rounded-lg border shadow-sm transition-opacity',
          isHovered
            ? 'opacity-100 border-indigo-300'
            : 'opacity-0 pointer-events-none border-transparent'
        )}
      >
        <FontAwesomeIcon
          icon="fa-regular fa-arrow-turn-left"
          className="text-indigo-500 text-xs"
        />
      </div>
    </div>
  );
};
